const scheduleMonFriSatSun =
  'contact_us_service_schedule_mon_fri_9_11_sat_sun_12_9';
const scheduleMonFri = 'contact_us_service_schedule_mon_fri_9_6';
const scheduleMonFriAlternative = 'contact-us-service-schedule-mon-fri-10-7';

export const DEFAULT_COUNTRY = 'international';

export const contactConfiguration = {
  tenants: {
    uk: {
      telephone: '+44 20 3936 3628',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    spain: {
      telephone: '+34 911 98 49 51',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    france: {
      telephone: '+33 1 76 41 06 22',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    italy: {
      telephone: '+39 06 9450 1300',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    germany: {
      telephone: '+49 3030808495',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    poland: {
      telephone: '+48 22 292 20 24',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    turkey: {
      telephone: '+44 20 3868 1652',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    lithuania: {
      telephone: '+370 5 211 1761',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    hungary: {
      telephone: '+36 1 808 8268',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    portugal: {
      telephone: '+351 308 800 017',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    latvia: {
      telephone: '+371 66 163 016',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    czech_republic: {
      telephone: '+420 228 880 192',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    greece: {
      telephone: '+30 21 1198 2561',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    },
    international: {
      telephone: '+1 888-950-8805',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    }
  },
  landlords: {
    spain: {
      telephone: '+34 911 98 49 50',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    uk: {
      telephone: '+44 20 3808 6520',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    italy: {
      telephone: '+39 06 9450 1302',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    ireland: {
      telephone: '+353 1 901 4051',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    france: {
      telephone: '+33 1 76 44 04 17',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    belgium: {
      telephone: '+32 2 808 52 17',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    germany: {
      telephone: '+49 30 200042090',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    austria: {
      telephone: '+43 720 116197',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    turkey: {
      telephone: '+90 212 900 26 23',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    poland: {
      telephone: '+48 22 292 20 26',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    lithuania: {
      telephone: '+370 5 211 1761',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    hungary: {
      telephone: '+44 20 3808 6520',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    latvia: {
      telephone: '+44 20 3808 6520',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    czech_republic: {
      telephone: '+44 20 3808 6520',
      schedule: scheduleMonFriAlternative,
      email: 'landlords@spotahome.com'
    },
    greece: {
      telephone: '+30 21 1198 2562',
      schedule: scheduleMonFri,
      email: 'landlords@spotahome.com'
    },
    international: {
      telephone: '+1 888-950-8805',
      schedule: scheduleMonFriSatSun,
      email: 'hello@spotahome.com'
    }
  },
  partnerships: {
    telephone: '+1 888-950-8805',
    schedule: scheduleMonFriSatSun,
    email: 'hello@spotahome.com'
  },
  other: {
    telephone: '+1 888-950-8805',
    schedule: scheduleMonFriSatSun,
    email: 'hello@spotahome.com'
  }
};

export const cities = {
  brussels: {
    country: 'belgium',
    region: 'france'
  },
  berlin: {
    country: 'germany',
    region: 'germany'
  },
  dublin: {
    country: 'ireland',
    region: 'uk'
  },
  milan: {
    country: 'italy',
    region: 'italy'
  },
  rome: {
    country: 'italy',
    region: 'italy'
  },
  barcelona: {
    country: 'spain',
    region: 'spain'
  },
  madrid: {
    country: 'spain',
    region: 'spain'
  },
  london: {
    country: 'uk',
    region: 'uk'
  },
  lisbon: {
    country: 'portugal',
    region: 'portugal'
  },
  valencia: {
    country: 'spain',
    region: 'spain'
  }
};

export default {
  DEFAULT_COUNTRY,
  contactConfiguration,
  cities
};
